import { Link } from "react-router-dom";

export const AboutUs = () => {

  return (
    <>
      <section className="bg-gradient-to-r from-blue-50 to-indigo-100 py-16 px-6 md:px-12">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 leading-tight">
              Nurture. Inspire. <br /> Grow with <span className="text-primary">Our Sunday School</span>
            </h1>
            <p className="text-gray-700 text-base leading-relaxed">
              At Our Sunday School, our mission is to nurture young hearts in the love and truth of Jesus Christ.
              We provide a safe, joyful, and engaging environment where children can explore God’s Word and grow spiritually.
            </p>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-primary opacity-10 rounded-[40px]"></div>
            <img
              src="images/online-study.png"
              alt="Our Sunday School"
              className="rounded-[40px] shadow-lg w-full object-cover relative"
            />
          </div>
        </div>
      </section>

      <section className="py-16 px-6 md:px-12 bg-white">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center">
          <div className="space-y-5">
            <h2 className="text-4xl font-bold text-gray-900">
              Our <span className="text-primary">Mission</span>
            </h2>
            <p className="text-gray-600 leading-relaxed text-sm md:text-base">
              Guided by Scripture, our Sunday School is dedicated to teaching biblical truths, fostering moral values,
              and encouraging children to build a personal relationship with God. Through interactive lessons, stories, songs, prayers,
              and activities, we aim to plant seeds of faith that will grow strong and last a lifetime.
            </p>
            <ul className="space-y-3 pt-4">
              <li className="flex items-center gap-2 text-gray-700 font-semibold text-sm">
                <span className="material-symbols-outlined bg-primary text-white rounded-full p-[4px] text-sm">
                  check
                </span>
                Nurture children’s knowledge, love, and devotion to Christ
              </li>
              <li className="flex items-center gap-2 text-gray-700 font-semibold text-sm">
                <span className="material-symbols-outlined bg-primary text-white rounded-full p-[4px] text-sm">
                  check
                </span>
                Encourage exploration of faith and spiritual habits
              </li>
              <li className="flex items-center gap-2 text-gray-700 font-semibold text-sm">
                <span className="material-symbols-outlined bg-primary text-white rounded-full p-[4px] text-sm">
                  check
                </span>
                Build a loving and supportive faith community
              </li>
            </ul>
          </div>

          <div className="border-[6px] border-[#D9D9D9] rounded-[40px]">
            <img
              src="images/mission-school.png"
              alt="Our Mission"
              className="rounded-[35px] w-full object-cover"
            />
          </div>
        </div>
      </section>

      <section className="py-16 px-6 md:px-12 bg-[#FAFAFA]">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our <span className="text-primary">Core Values</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto mb-10 text-sm md:text-base">
            These principles guide our teaching and shape the hearts of every child who joins our Sunday School.
          </p>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: "lightbulb", title: "Faith", text: "We instill a strong love for God and biblical teachings." },
              { icon: "groups", title: "Community", text: "We create a safe and supportive environment for children and families." },
              { icon: "verified", title: "Integrity", text: "We encourage honesty, kindness, and Christ-centered values." },
              { icon: "favorite", title: "Passion", text: "We are dedicated to nurturing young hearts with love and care." },
            ].map((val, i) => (
              <div
                key={i}
                className="flex flex-col items-center text-center bg-blue-50 p-6 rounded-2xl hover:bg-blue-100 transition"
              >
                <span className="material-symbols-outlined text-primary text-4xl mb-3">
                  {val.icon}
                </span>
                <h4 className="font-bold text-lg mb-2 text-gray-900">{val.title}</h4>
                <p className="text-gray-600 text-sm">{val.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 px-6 md:px-12 bg-gradient-to-r from-primary to-blue-600 text-white text-center">
        <div className="max-w-4xl mx-auto space-y-6">
          <h2 className="text-4xl font-bold leading-tight">
            Ready to Nurture Young Hearts in Faith?
          </h2>
          <p className="text-white/90 text-base max-w-2xl mx-auto">
            Join our Sunday School and help children grow in knowledge, love, and devotion to Christ through engaging lessons, mentorship, and community.
          </p>
          <Link to="/signup">
            <button className="bg-white text-primary px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition mt-5">
              Get Started Now
            </button>
          </Link>
        </div>
      </section>
    </>
  );
};